import api from "./api";

export const getColaboradores = async (texto, page, limit) => {
  const response = await api.get("/colaboradores", {
    params: { texto, page, limit },
  });
  return response.data;
};

export const createColaborador = async (collaborator) => {
  const response = await api.post("/colaboradores", collaborator);
  return response.data;
};

export const updateColaborador = async (id, collaborator) => {
  const response = await api.put(`/colaboradores/${id}`, collaborator);
  return response.data;
};

export const deleteColaborador = async (id) => {
  const response = await api.delete(`/colaboradores/${id}`);
  return response.data;
};

export const importColaboradores = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/colaboradores/importar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};
